import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { RecipientsApi, RequestStrategyEnum, type RecipientGetRecentRequest, type RecipientResponse, type WithSignal } from '@shared/api';

const getRecentEffect = createEffect(({ signal, ...request }: WithSignal<RecipientGetRecentRequest> = {}) =>
  RecipientsApi.getRecentRecipients(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse[]>([])
  .on(getRecentEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getRecentEffect.pending, (_, data) => data)
  .on(getRecentEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getRecentEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getRecentEffect, () => null)
  // .on(getRecentEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getRecentEffect.fail, () => 'Something went wrong while fetching Recipients. Please try again.')
  .on(getRecentEffect.done, () => null)
  .reset(clearEvent);

const getRecentApi = ApiUtilsV2.wrapperApi(getRecentEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getRecentApi.cancel());

export const $recipientRecentStore = {
  events: {
    getRecent: getRecentApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
